import axios from 'axios'
import store from '@/store/index'

let protocolPrefix = process.env.NODE_ENV === 'production' ? 'https' : 'https'
let protocolPort = process.env.NODE_ENV === 'production' ? '' : ':'
let hostUrl = process.env.NODE_ENV === 'production' ? 'talentogrupoitalcol.com' : 'talentogrupoitalcol.com'


axios.defaults.headers.common.Accept = 'application/json'

if(process.env.NODE_ENV === 'production'){
  axios.defaults.baseURL = `${protocolPrefix}://${hostUrl}${protocolPort}/apiempleabilidad/api`
}else{
  axios.defaults.baseURL = `${protocolPrefix}://${hostUrl}${protocolPort}/apiempleabilidad/api`
}

const auth = {
    getUser: params => axios.post('login', { params }),
    logout: () => axios.post('logout'),
    resetpass: params => axios.post('resetpass', { params }),
    savenewpass: params => axios.post('savenewpass', { params }),
    getpermisos: id => axios.get(`getpermisos/${id}`),
  } 

const app = {
    getVacantes: params => axios.get('getVacantes', { params }),
    saveVacante: params => axios.post('saveVacantes', { params }),
    updateVacante: params => axios.post('updateVacantes', { params }),
    savePostulacion: function(params,adjhojavida){

      let formData = new FormData();
  
      formData.append('adjhojavida', adjhojavida);
      formData.append('data', JSON.stringify(params));
      
  
      return new Promise(function(resolve) {
        axios.post('savePostulacion' , formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(function(res) {
          
          resolve(res)      
          
        })
        .catch(function(error) {   
          
          resolve(error.response)
            
        })
      })
  
  
    },
    getVacantesVisualizacion: params => axios.get('getVacantesVisualizacion', { params }),
    getPostuladosVacante: params => axios.post('getPostuladosVacante', { params }),
    getPostulado: params => axios.post('getPostulado', { params }),
    getdashboard: empresa_id => axios.get(`getdashboard/${empresa_id}`),
    getArchivoHojaVida: (params, responseType) => axios.get('getArchivoHojaVida', { params: params, responseType: responseType }),

    saveVisitaVacante: params => axios.post('saveVisitaVacante', { params }),
    saveAprobacionPostulacion: params => axios.post('saveAprobacionPostulacion', { params }),
    CancelarVacante: params => axios.post('CancelarVacante', { params }),
    TerminarVacante: params => axios.post('TerminarVacante', { params }),
    
}

const administracion = {
  getDepartamentos: params => axios.get('getDepartamentos', { params }),
  getCiudadesXIdDepartamento: id => axios.get(`getCiudadesXIdDepartamento/${id}`),
  getTiposIdentificacion: params => axios.get('getTiposIdentificacion', { params }),
  getEmpresas: params => axios.get('getEmpresas', { params }),
}

  axios.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
    }, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if(error.response.status === 401) {
        // redirect to login page
        store.dispatch("logout", 401)
    }
    return Promise.reject(error);
  });

export {
    auth,
    app,
    administracion
}